<template>
  <div
    class="d-flex flex-wrap p-2"
  >
    <div class="d-flex flex-column mb-2 w-100 w-sm-50">
      <span class="text-secondary property-label">
        Key
      </span>
      <span class="text-main">
        {{ versionData.key }}
      </span>
    </div>
    <div class="d-flex flex-column w-100 w-sm-50 mb-2">
      <span class="text-secondary property-label">
        Bucket name
      </span>
      <span class="text-main">
        {{ versionData.bucketName }}
      </span>
    </div>
    <div class=" d-flex flex-column w-100 w-sm-50 mb-2">
      <span class="text-secondary property-label">
        Version ID
      </span>
      <span class="text-main">
        {{ viewingVersionId }}
      </span>
    </div>
    <div class="d-flex flex-column w-100 w-sm-50 mb-2">
      <span class="text-secondary property-label">
        Permissions
      </span>
      <span class="text-main">
        {{ versionData.isPublic ? 'Public' : 'Private' }}
      </span>
    </div>
    <div class=" d-flex flex-column w-100 mb-2">
      <span class="text-secondary property-label">
        Type
      </span>
      <span class="text-main">
        {{ versionData.contentType }}
      </span>
    </div>
    <div class="d-flex flex-column w-100 w-sm-50 mb-2">
      <span class="text-secondary property-label">
        Size
      </span>
      <span class="text-main">
        {{ formatBytes(versionData.contentLength) }}
      </span>
    </div>
    <div class=" d-flex flex-column w-100 w-sm-50 mb-2">
      <span class="text-secondary property-label">
        Last Modified
      </span>
      <span class="text-main">
        {{ formatOffsetDateTime(versionData.lastModified) }}
      </span>
    </div>
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  name: 'FileVersionProperties',
  mixins: [helpers],
  props: {
    viewingVersionId: {
      type: String,
      default: null,
      required: true,
    },
    versionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {}
  },
}
</script>
